module.exports = __webpack_public_path__ + "media/images/talent/lp/case01-f24718e9fcb529f5d94f48c51681a55f.png";